// extracted by mini-css-extract-plugin
module.exports = {"choice":"FdQRVFbU0H_uunUhU227g","a":"_2QKMaG4DHKUM-OHpGjQNjG","b":"_3J6rck4XDG6l6NXWLoDQ42"};